export const ThemeRoutes = {
  SimpleRoutes: [],
  LangRoutes  : []
}

export const ThemeGuards = {
  onReady   : {},
  beforeEach: {},
  afterEach : {}
}

export default ThemeRoutes
